import {
  CardContent 
 ,Box 
 ,Link
} from 'external/material'

import LinkBehavior from './Link'
import Card from './Card'
import Cover from './Cover'
import Group from 'components/Group'
import Teacher from 'components/Teacher'
import Assignments from './Assignments'

export default function CourseItem(props) {
  const {group} = props
  return (
      <Card>
        <Link groupId={group.id} component={LinkBehavior} underline="none" target="units">
          <Cover {...group} />
        </Link>
        <CardContent>
          <Link groupId={group.id} component={LinkBehavior} underline="none" target="units" sx={{display: 'flex'}}>
            <Box className="courseName">
              {group.courseName}
            </Box>
          </Link>
          <Teacher {...group} />
          <Group {...group} />
          <Assignments {...group} />
        </CardContent>
      </Card>
  )
}
